import { inject, Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { FiscalProfileService } from "src/app/services/fiscal-profile.service";
import { UserService } from "src/app/services/user.service";

@Injectable()
export class ProvideFiscalProfilesGuard {
  private readonly fiscalProfileService = inject(FiscalProfileService);
  private readonly userService = inject(UserService);

  async canActivate(): Promise<boolean> {
    try {
      if (this.userService.able("read", "fiscal-profile")) {
        await lastValueFrom(this.fiscalProfileService.rewarm());
      } else {
        this.fiscalProfileService.warm([]);
      }
    } catch (ex) {
      this.fiscalProfileService.warm([]);
    }

    return true;
  }
}
